import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Daily Financial Recording System',
    shortName: 'Daily Financial',
    description: 'Catat pemasukan dan pengeluaran harian, pantau saldo, dan pahami kebiasaan belanjamu dalam satu dasbor keuangan pribadi yang rapi.',
    url: getOrigin()
}
